import SoundPlayerModal from './SoundPlayerModal';

export default SoundPlayerModal;
